import { CatHeading } from '@blocks-react/components/Heading';
import { CustomStyledLabel } from '../../../../request-service';
import { ComponentProps, FC, PropsWithChildren } from 'react';
type CatHeadingProps = ComponentProps<typeof CatHeading>;

export const PartsDiagramErrorHeading: FC<
  PropsWithChildren<CatHeadingProps>
> = ({ children, ...headingProps }) => (
  <CatHeading variant="label-lg" {...headingProps}>
    <CustomStyledLabel>{children}</CustomStyledLabel>
  </CatHeading>
);
